// extracted by mini-css-extract-plugin
export var icon = "_6o-1";
export var subtext = "_6o-0";